module.exports = __webpack_public_path__ + "static/meistertask-ebd82f6bc91e7121baa5e6647f5c8ba5.svg";